exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add[data-v-fd7b57c2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-bottom:20px}.page[data-v-fd7b57c2]{margin-top:20px}.avatar[data-v-fd7b57c2]{width:120px;height:80px}.el-icon-plus[data-v-fd7b57c2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px dashed #dbdbdd}.img[data-v-fd7b57c2]{height:60px}\n", ""]);

// exports
